<template>
  <div>

  <div v-if="idioma == 'Español' ">
      <div><h2>
        ¡Hola! Soy Víctor Fernández, Diseñador de
        <span><u> Producto + Interactivo,</u> </span> he trabajado durante los
        últimos años investigando y diseñando productos digitales en campos
        relacionados con
        <u
          >funcionalidad, experiencia de usuario, interfaz de usuario,
          arquitectura de la información e interacción.
        </u>
      </h2></div>
  </div>

  <div  v-if="idioma == 'Inglés' ">
      <div><h2>
        Hello! I'm Víctor Fernández,
        <span><u>a Product + Interactive</u> </span> Designer, I've worked last years researching and designing digital products in related fields as 
        <u
          >funcionality, user experience, user interface, information archiquecture and interaction
        </u>
      </h2></div>
  </div>

  


  </div>

</template>

<script>
export default {
  name: "Resume",
  props: ['idioma'],
  data: function() {
    return {
      resumenEspañol: ``,
      resumeEnglish:``,
      spanish:false,

    };
  },
  watch:{

  }
};
</script>

<style lang="scss">

  h2 {
    text-align: left;
    font-size: 5.4vw;
    text-align: left;
    font-weight: 300;
    line-height: 150%;
    span {
      font-weight: 500;
    }
  }


@media (min-width: 500px) {

    
    h2 {
      text-align: left;
      font-size: 2rem;
      text-align: left;
      font-weight: 300;
      line-height: 150%;
      span {
        font-weight: 500;
      }
    }
}

@media (min-width: 1024px) {

    h2 {
      width: 80vw;
      text-align: left;
      font-size: 2.7vw;
      text-align: left;
      font-weight: 300;
      line-height: 160%;
      span {
        font-weight: 500;
      }
    }
}
</style>
